(function() {
    'use strict';

    goToAnchor();
    init();

    function init() {
        var links = document.querySelectorAll('.header__sub-nav .sub-nav__link')
        var lang = document.documentElement.lang;

        for (var i = 0, max = links.length; i < max; i++) {
            var href = links[i].getAttribute('href');
            if (href.indexOf("#") != -1) {

                links[i].addEventListener("click", function(event) {

                    var current_url = window.location.href;
                    var indexSearch;

                    var templateName = document.querySelector('body').classList.contains('template--products');

                    if (lang == 'fr') {
                        indexSearch = current_url.indexOf("/produits/");
                    } else if (lang == 'en') {
                        indexSearch = current_url.indexOf("/products/");
                    }

                    if (indexSearch > 0 && current_url.indexOf('#') != -1) {
                        event.preventDefault();
                    }


                    var url = this.getAttribute('href'), idx = url.indexOf("#")
                    var hash = idx != -1 ? url.substring(idx+1) : "";
                    triggerProduct(hash);
                });
            }
        }
    }

    function goToAnchor() {
        var url = window.location.href, idx = url.indexOf("#")
        var hash = idx != -1 ? url.substring(idx+1) : "";

        if (hash) {
            setTimeout(function() {
                triggerProduct(hash)
            }, 500);
        }
    }

    function triggerProduct(hash) {
        var element = document.querySelector('[gr-grid-expander-slug="' + hash + '"]');
        $(element).find('.grid-expander__trigger').trigger('click');
    }



})();
